import { BASE_URL } from "@/api/system/post"
import { createFormItem } from "@/component-create/utils/create-form-item"
import { FormDialog } from "@/component-create/FormDialog"
import { FORM_ITEM } from "@/components/form/enums"


/**
 * 绘制新增表单
 */
 export function renderAddForm(el: Element) {
  const addForm = new FormDialog(
    el, 
    { 
      items: items, 
      elFormProps: { rules: rules }, 
      saveUrl: BASE_URL 
    },
    '新增'
  )

  return addForm
}

const items = [
  [
    createFormItem('岗位编码', 'postCode', FORM_ITEM.INPUT, { clearable: true, maxlength: '20' })
  ],
  [
    createFormItem('岗位名称', 'postName', FORM_ITEM.INPUT, { clearable: true})
  ],
  [
    createFormItem('状态', 'status', FORM_ITEM.SELECT, { loader: 'EOD', default: true, }),
    createFormItem('排序', 'sort', FORM_ITEM.INPUT_NUMBER, { clearable: true ,min: 0})
  ],
  [
    createFormItem('备注', 'remark', FORM_ITEM.INPUT, { type: 'textarea', rows: 3, maxlength: '200', showWordLimit: true }),
  ]
]

const rules = {
  postCode: [{ required: true, message: '请输入岗位编码', trigger: 'blur' }],
  postName: [{ required: true, message: '请输入岗位名称', trigger: 'blur' }],
  status: [{ required: true, message: '请选择参数状态', trigger: 'blur' }],
  sort: [{ required: true, message: '请输入排序', trigger: 'blur' }]
}